import React, { useContext, useEffect, useRef, useState } from 'react';
import { ApiContext } from '@api/api';
import { CargoTemplateWithoutIdDTO } from '@api/ringil-api.v2';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  value: CargoTemplateWithoutIdDTO;
  companyId: string;
  onChange: (sku: CargoTemplateWithoutIdDTO) => void;
  style?: any;
  disabled?: boolean;
  dataTestId?: string;
}

const InputSKUPlain: React.FC<ComponentProps> = ({ value, companyId, onChange, style, disabled = false, dataTestId }) => {
  const [cargoItemTypes, setCargoItemTypes] = useState<CargoTemplateWithoutIdDTO[]>([]);
  const { lovCargoItemTypeForCompany } = useContext(ApiContext);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    lovCargoItemTypeForCompany(companyId, data => {
      setCargoItemTypes(data);
    });
  }, [companyId]);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-dropdown', dataTestId);
  }, [cargoItemTypes, dataTestId]);

  return (
    <div ref={wrapperRef}>
      <Dropdown
        value={value}
        dataKey="code"
        options={cargoItemTypes}
        onChange={e => onChange(e.target.value)}
        optionLabel="name"
        style={style}
        disabled={disabled}
        itemTemplate={(option: CargoTemplateWithoutIdDTO) => (
          <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option?.name || option?.code || '')}` : undefined}>{option?.name}</span>
        )}
      />
    </div>
  );
};

export default InputSKUPlain;
